console.log('Custom JS - add-to-cart-form');

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
  cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) {
          return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
      case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
      case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
      case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
  }
  return formatString.replace(placeholderRegex, value);
};

function reInitTriggerClick(){
  console.log('reInitTriggerClick');
  $(".quick-view-trigger").click(function(){
       jQuery(this).closest('.card--product').find('.js-quick-add').trigger("click");

    });
    $(".atc-options").click(function(){
      jQuery(this).closest('.card--product').find('.atc-options-wrapper').addClass("open");

    });
    $(".close_quick").click(function(){
       jQuery(this).closest('.card--product').find('.atc-options-wrapper').removeClass("open");
    });

   $(".purchase_option").click(function(){
    var valueOption = $(this).data('option');
    console.log(valueOption);
    
    if(valueOption == 'sub'){
      $(this).closest('.wrap-subscription').find('.selling_plan_product').attr('name','selling_plan');
    }else{
      $(this).closest('.wrap-subscription').find('.selling_plan_product').attr('name','');
    }
  });

  var labelOptions = document.querySelectorAll(".option-selector label.opt-label--btn");
  for (let i = 0; i < labelOptions.length; i++) {
     labelOptions[i].addEventListener("click", function() {
       var product_id = labelOptions[i].getAttribute('data-product-id');
       var variant_id = labelOptions[i].querySelector('input').value;
       $('form#product-form-'+product_id).find('[name="id"]').val(variant_id);
       var variant_price_ot = labelOptions[i].querySelector('input').dataset.price;
       var variant_price_sub = labelOptions[i].querySelector('input').dataset.priceSub;
       console.log(variant_price_ot);
       console.log(variant_price_sub);
       $('form#product-form-'+product_id).find('.ot-price').text(variant_price_ot);
       $('form#product-form-'+product_id).find('.sub-price').text(variant_price_sub);
     });
  }
  
}


document.addEventListener('on:variant:change', (event) => {
  console.log(event);
  setTimeout(function() {
     var variant_price_ot = event.detail.variant.selling_plan_allocations[0].compare_at_price;
     var variant_price_sub = event.detail.variant.selling_plan_allocations[0].price;
    console.log(Shopify.formatMoney(variant_price_ot,$('body').data('money-format')));
    console.log(Shopify.formatMoney(variant_price_sub,$('body').data('money-format')));
     $('.quick-add-drawer .rc-widget .rc-ot-price').text(Shopify.formatMoney(variant_price_ot,$('body').data('money-format')));
     $('.quick-add-drawer .rc-widget .rc-sub-price').text(Shopify.formatMoney(variant_price_sub,$('body').data('money-format')));
    }, 500);
});



document.addEventListener('on:quickbuy:after-open', (event) => {
  //console.log('on:quickbuy:after-open');
  //console.log(event);
  setTimeout(function() {
     $(".quick-add__product-details .rc-widget .rc-radio__input").change(function(){
       if( $(this).is(":checked") ){ // check if the radio is checked
           var valueOption = $(this).val(); // retrieve the value
           //console.log(valueOption);
           var idOption =  $(this).attr('id');
           
           if(valueOption == 'subscription'){
             $(this).closest('.quick-add-drawer').find('#product-form-quickadd .rc-selling-plans-dropdown__select').attr('name','selling_plan');
           }else{
             $(this).closest('.quick-add-drawer').find('#product-form-quickadd .rc-selling-plans-dropdown__select').attr('name','');
           }
        }
    });

    $('.quick-add__product-details .rc-widget .rc-selling-plans-dropdown__select').on('change', function() {
      //console.log( this.value );
      $(this).closest('.quick-add-drawer').find('#product-form-quickadd .rc-selling-plans-dropdown__select').val(this.value).change();
    });
    
  }, 500);
 
});

$(document).ready(function(){
  
  reInitTriggerClick();
  
  setTimeout(function() {
    reInitTriggerClick();
  }, 5000);

  setTimeout(function() {
    reInitTriggerClick();
  }, 10000);
    
  setTimeout(function() {
    reInitTriggerClick();
  }, 15000);
  
});